import { CartItemListing } from '../../components/Cart/CartItemListing';
import { CartTotalsTable } from '../../components/Cart/CartTotalsTable';
import { useTranslation } from '../../i18n/i18n';
import { useCart } from '../../state/cart';
import { ApiCheckoutState } from '../../types';
import { ContentCard } from '../ContentCard/ContentCard';
import { DeliveryInput, DeliveryModel } from '../Form/DeliveryInput';
import { KlarnaCheckout } from './KlarnaCheckout';

type Props = {
	state: ApiCheckoutState;
	onChange: (model: ApiCheckoutState) => void;
	homeDeliveryEnabled: boolean;
};

export const CheckoutPrivate = ({ state: checkoutState, onChange, homeDeliveryEnabled }: Props) => {
	const t = useTranslation().checkout;
	const { cart, setQuantity } = useCart();

	async function handleChange(model: DeliveryModel) {
		onChange({
			...checkoutState,
			delivery: {
				...checkoutState.delivery,
				type: model.type,
				notification: model.notification,
			},
		});
	}

	return (
		<div>
			<ContentCard title={t.deliveryMethod}>
				<DeliveryInput
					hideDoor
					homeDeliveryEnabled={homeDeliveryEnabled}
					onChange={(e) => handleChange(e)}
					model={checkoutState.delivery}
					customerType={checkoutState.customerType}
					renderedInCheckout
				/>
			</ContentCard>
			<ContentCard title={t.checkYourCart} className="checkout-cart">
				<CartItemListing items={cart.items} onSetQuantity={setQuantity} />
				<div className="mb-3"></div>
				<CartTotalsTable cart={cart} />
			</ContentCard>
			{cart.items.length > 0 && (
				<ContentCard>
					<KlarnaCheckout cart={cart} deliveryType={checkoutState.delivery.type} />
				</ContentCard>
			)}
		</div>
	);
};
